import React from "react";
import { CssBaseline, AppBar, Toolbar, Box } from "@material-ui/core";
import useAppBarStyles from "./AppBarStyles";
import { AppBarProps } from "./AppBar.d";

const ReplenishmentAppBar: React.FC<AppBarProps> = ({ leftChildren, centreChildren, rightChildren }) => {
	const classes = useAppBarStyles();

	return (
		<Box flexGrow={1}>
			<CssBaseline />
			<AppBar position="fixed" className={classes.appBar}>
				<Toolbar classes={{ regular: classes.toolbar }}>
					{leftChildren}
					{centreChildren}
					{rightChildren}
				</Toolbar>
			</AppBar>
		</Box>
	);
};
export default ReplenishmentAppBar;
